import { ListView, Divider } from '@modulor/react';
import React, { memo, useMemo } from 'react';
import arePropsEqual from 'react-fast-compare';
import NavigationCell from './NavigationCell';
import type { NavigationItem } from '../types';
import styles from './styles.module.css';
import NavigationCellSkeleton from './NavigationCellSkeleton';
import { createMockEntitiesArray } from '../../../../utils';

type NavigationListProps = {
  items: NavigationItem[];
  isLoading: boolean;
  sectionIndex: number;
  header?: React.ReactNode;
  withoutDivider?: boolean;
};

const SKELETONS_COUNT = 5;

const loaders = createMockEntitiesArray(SKELETONS_COUNT) as NavigationItem[];

const NavigationList = ({
  header,
  isLoading,
  items,
  withoutDivider,
  sectionIndex,
}: NavigationListProps) => {
  const cells = useMemo(
    () => (isLoading ? loaders : items),
    [isLoading, items]
  );

  return !cells?.length ? null : (
    <>
      {!withoutDivider && <Divider />}
      <div className={styles.container}>
        <ListView
          header={header}
          headerNoPadding={!!header}
          className={styles.list}
        >
          {cells?.map((cell, index) =>
            isLoading ? (
              <NavigationCellSkeleton key={cell.id} />
            ) : (
              <NavigationCell
                key={cell.id}
                {...cell}
                analyticsData={{
                  ...(cell?.analyticsData || {}),
                  position_index: index,
                  section_index: sectionIndex,
                }}
              />
            )
          )}
        </ListView>
      </div>
    </>
  );
};

export default memo(NavigationList, arePropsEqual);
